module.exports = __webpack_public_path__ + "static/media/Empty.3f9fd2c7.png";